import React, { useContext } from 'react';
import { CardValueTitle } from 'spw-programming-projects/program-summary/components/styles';
import { Box, Grid } from '@mui/material';
import {
  CardBoldValue,
  SmallCard,
  SmallCardRow,
  SmallCardTitle,
} from 'spw-components/project-details-tabs/program-summary/esa-single-page-summary/styles';
import { asRatio } from 'spw-shared/utils';
import { isFinite, isNaN } from 'lodash';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { ProgramSummaryCardsContext } from 'spw-esa-projects/program-summary/summary-cards';
import { PaddedCardTitle } from 'spw-programming-projects/program-summary/single-page-summary/styles';
import { useSelector } from 'react-redux';
import {
  selectHeadcountValue,
  selectKeyData,
} from 'spw-redux/modules/program-summary/esa/selectors';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';

export const DeskSharingRatioCard = () => {
  const { showRsf, selectedCardIcon, onClickCardIcon } = useContext(
    ProgramSummaryCardsContext
  );
  const headcountValue = useSelector(selectHeadcountValue);
  const keyData = useSelector(selectKeyData);
  const relation = headcountValue / keyData.workseats;
  const cardIcon = useCardIcon(ProgramSummaryCardType.deskSharingRatio);

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType === ProgramSummaryCardType.deskSharingRatio;

  const displayedRelation =
    !isNaN(relation) && isFinite(relation) && !!relation
      ? asRatio(relation, 2, true)
      : NO_DATA_TO_SHOW;

  if (!cardIcon) return null;

  return (
    <SmallCard $tall={showRsf}>
      {showRsf ? (
        <PaddedCardTitle>Desk Sharing</PaddedCardTitle>
      ) : (
        <SmallCardTitle>Desk Sharing</SmallCardTitle>
      )}
      <Grid container>
        <Grid item xs={12}>
          <SmallCardRow display="flex">
            <Box ml={0.5} mr={2.5}>
              <CardIcon
                iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                onClick={handleIconClick}
                height={32}
                isSelected={isIconCardSelected}
              />
            </Box>
            <CardBoldValue data-testid="desk_sharing_ratio_card">
              {displayedRelation}
            </CardBoldValue>
          </SmallCardRow>
          <CardValueTitle>
            Headcount /<br />
            Work Seats
          </CardValueTitle>
        </Grid>
      </Grid>
    </SmallCard>
  );
};
